var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmTrixBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 0C25.9729 0 22.3562 3.36328 21.3208 7.90781C21.2042 7.90781 21.1167 7.875 21 7.875C15.8521 7.875 11.6667 12.5836 11.6667 18.375C11.6667 19.1625 11.7542 19.9336 11.9146 20.6719C7.65625 22.6406 4.66667 27.3328 4.66667 32.8125C4.66667 34.8797 5.13333 36.7992 5.87708 38.5383C2.37708 40.8023 0 45.0023 0 49.875C0 55.3383 2.975 60.0305 7.20417 61.9992C7.07292 62.7539 7 63.525 7 64.3125C7 70.8422 11.6958 76.125 17.5 76.125C18.0979 76.125 18.6812 76.043 19.25 75.9281C20.65 80.6039 24.5292 84 29.1667 84C34.9708 84 39.6667 78.7172 39.6667 72.1875V10.5C39.6667 4.70859 35.4812 0 30.3333 0ZM84 49.875C84 45.0023 81.6229 40.8023 78.1229 38.5383C78.8812 36.7992 79.3333 34.8797 79.3333 32.8125C79.3333 27.3328 76.3437 22.6406 72.0854 20.6719C72.2312 19.9336 72.3333 19.1625 72.3333 18.375C72.3333 12.5836 68.1479 7.875 63 7.875C62.8833 7.875 62.7812 7.90781 62.6792 7.90781C61.6437 3.36328 58.0271 0 53.6667 0C48.5187 0 44.3333 4.69219 44.3333 10.5V72.1875C44.3333 78.7172 49.0292 84 54.8333 84C59.4708 84 63.35 80.6039 64.75 75.9281C65.3187 76.043 65.9021 76.125 66.5 76.125C72.3042 76.125 77 70.8422 77 64.3125C77 63.525 76.9271 62.7539 76.7958 61.9992C81.025 60.0305 84 55.3383 84 49.875Z",
    fill: "url(#paint0_linear_184_434)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_434",
    x1: 0,
    y1: 42,
    x2: 84,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18487F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C4F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmTrixBrain);
export default __webpack_public_path__ + "static/media/PharmTrix Brain.f8837fa58cfa42e00134da95775bd7bd.svg";
export { ForwardRef as ReactComponent };